import { BASE_URL, initApi } from "../initApi";
import axios from "axios";

// ----------------------- EVALUATION - CART - POST EVALUATION DATA
export async function postEvalData(id) {
  return initApi().then(() => {
    return axios.post(`${BASE_URL}/api/evaluation/function`, {
      functionId: id,
    });
  });
}
